// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1o29tXD0 center py2"};